// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-filter-menu .mp-filter-menu-header{border-bottom:1px solid var(--component-outline-color);display:none}.mp-filter-menu .mp-filter-menu-header.is-visible{display:flex}.mp-filter-menu mp-select.mp-filter-menu-cohort-options{flex:1;margin:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
